export const OrderStatus = {
  New: 'new',
  Paid: 'paid',
  BloodPending: 'blood-pending',
  BloodReceived: 'blood-received',
  SampleReceived: 'sampleReceived',
  Completed: 'completed',
  NotCompleted: 'not-completed',
  Cancelled: 'cancelled',
};

export const OrderImportStatus = {
  Initiated: 'initiated',
  Started: 'started',
  Completed: 'completed',
  NoImport: 'undefined',
};

export const OrderReview = {
  auto: 'auto',
  written: 'written',
  consultation: 'consultation',
};

export interface Order {
  id: number;
  sessionId?: number;
  customerId?: number;
  patientId?: number;
  remoteId?: number;
  email: string;
  firstName: string;
  lastName: string;
  hash: string;
  phone: string;
  isBloodRegistered: boolean;
  status: string;
  importStatus: keyof typeof OrderImportStatus;
  createdAt: string;
  amount: number;
  researchMemberId: string;
  paymentMethod?: string;
  paidAt?: string;
  resultsUrl: string;
  commentResult: string;
  commentUnidentified: string;
  subtotal: number;
  discount: number;
  couponCode: string;
  productKey: string;
  productTitle?: string;
  productId: number;
  productIsTest?: boolean;
  personCode: string;
  childCode: string;
  patientIsChild: boolean;
  patientName: string;
  patientLastName: string;
  patientAge: string;
  patientBirthDate?: string;
  patientHash?: string;
  isConsultation: boolean;
  administratorId: number;
  review: keyof typeof OrderReview;
  isAsit: boolean;
  daysToDeadline: number;
  currencyCode: string;
  siteId: number;
  siteTitle: string;
  pdfId?: string;
  pdfIds?: Record<string, string>;
  isGift?: boolean;
  testId?: number;
  shopifyOrderId?: string;
  shopifyOrderNumber?: string;
  region?: 'eu' | 'uk' | 'us';
  thrivaOrderId?: string;
  thrivaUserId?: string;
  thrivaSentAt?: string;
  customerAddress?: string;
  customerCity?: string;
  customerState?: string;
  customerZipCode?: string;
  customerCountryCode?: string;
  parcelTerminalName?: string;
  parcelTerminalAddress?: string;
  parcelTerminalCity?: string;
  surveyFinished?: boolean;
}
